// The Vue moment filter does the same thing as the AngularJS moment filter.
import momentFilter from '@/filters/moment';

export { momentFilter };
